<template>
  <div class="comment">
    <h4>{{ comment.author.name }}</h4>
    <p class="commentMeta">{{ commentDate }}<p>
    <div class="commentContent" v-html="comment.content"></div>
    <comment-form :postId="postId" :parentId="comment.id" v-if="replying" :child="true"></comment-form>
    <button class="button button-underline" v-if="!replying && comment.depth < 5" @click="toggleReply">Reply</button>
    <div v-if="children">
      <child-comments v-if="children.length" :comments="children" :childComments="childComments" :postId="postId"></child-comments>
    </div>
  </div>
</template>

<script>
import CommentForm from './CommentForm'
export default {
  name: 'comment',
  props: ['comment', 'postId', 'childComments'],
  data () {
    return {
      replying: false
    }
  },
  beforeCreate: function () {
    this.$options.components.ChildComments = require('./ChildComments')
  },
  methods: {
    toggleReply () {
      this.replying = !this.replying
    }
  },
  components: {
    CommentForm
  },
  computed: {
    commentDate () {
      let vm = this
      return vm.$moment(vm.comment.date).format('MMMM D, YYYY [at] h:mm a')
    },
    children () {
      let vm = this
      if (vm.childComments) {
        return vm.childComments.filter((cc) => {
          return parseInt(cc.parent) === parseInt(vm.comment.id)
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

.comment
  margin: 20px 0
  padding: 36px 24px
  border-radius: 10px
  background: white
  h4
    font-size: 22px
    font-weight: bold
    margin-top: 0
    margin-bottom: 0
  p.commentMeta 
    font-size: 16px
    margin-bottom: 1rem
  .childComments
    border-left: 1px solid #ccc
    .comment
      padding-top: 0
      padding-bottom: 0
      margin-top: 30px
      margin-bottom: 30px
      &:last-child
        margin-bottom: 0

button.button-underline
  border-color: $turqoise
</style>

<style lang="sass">
@import ../../assets/styles/mixins

.commentContent
  p
    &:first-child
      margin-top: 0px
  &:last-child
    p:last-child
      margin-bottom: 0
</style>



// WEBPACK FOOTER //
// Comment.vue?57bc4fc8